import { createSimplePageStrategy } from './simple-page.strategy-helper';

export const TermsAndConditionsSeoStrategy = createSimplePageStrategy(
  'termsAndConditions',
  'terms-and-conditions',
  '/terms-and-conditions'
);
